"use strict";
"use es6";

/* *
 *
 *  Imports
 *
 * */
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _DrawPoint = _interopRequireDefault(require("../../Mixins/DrawPoint"));
var _SeriesRegistry = _interopRequireDefault(require("../../Core/Series/SeriesRegistry"));
var _Utilities = _interopRequireDefault(require("../../Core/Utilities"));
var __extends = void 0 && (void 0).__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return _extendStatics(d, b);
  };
  return function (d, b) {
    _extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var ScatterSeries = _SeriesRegistry.default.seriesTypes.scatter;
var extend = _Utilities.default.extend,
  isNumber = _Utilities.default.isNumber;
/* *
 *
 *  Class
 *
 * */
var VennPoint = /** @class */function (_super) {
  __extends(VennPoint, _super);
  function VennPoint() {
    /* *
     *
     *  Properties
     *
     * */
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.options = void 0;
    _this.series = void 0;
    return _this;
    /* eslint-enable valid-jsdoc */
  }
  /* *
   *
   *  Functions
   *
   * */
  /* eslint-disable valid-jsdoc */
  VennPoint.prototype.isValid = function () {
    return isNumber(this.value);
  };
  VennPoint.prototype.shouldDraw = function () {
    var point = this;
    // Only draw points with single sets.
    return !!point.shapeArgs;
  };
  return VennPoint;
}(ScatterSeries.prototype.pointClass);
extend(VennPoint.prototype, {
  draw: _DrawPoint.default.drawPoint
});
/* *
 *
 *  Default Export
 *
 * */
var _default = exports.default = VennPoint;
module.exports = exports.default;